
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

interface AuthenticateShopifyRequest {
    shopUrl: string;
    companyId?: string;
}

interface AuthenticateShopifyResponse {
    authUrl: string;
}


const authenticateShopify = async (shopUrl: string, companyId?: string): Promise<AuthenticateShopifyResponse> => {
    const authenticateShopify = httpsCallable<AuthenticateShopifyRequest, any>(functions, 'shopify_auth');
    const result = await authenticateShopify({ shopUrl, companyId });

    console.log('hide website result', result)
    return result.data;
};

export { authenticateShopify };
